<template>
  <span class="svg-ico-magnifier-zoom">
    <svg :style="`width:${width}px;height:${width}px;fill:none;`" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M16.1049 17.1603C12.962 19.7709 8.2894 19.6031 5.34315 16.6569C2.21895 13.5327 2.21895 8.46734 5.34315 5.34315C8.46734 2.21895 13.5327 2.21895 16.6569 5.34315C19.6013 8.2876 19.7707 12.9563 17.165 16.0991L20.7848 19.7189C21.0777 20.0117 21.0777 20.4866 20.7848 20.7795C20.4919 21.0724 20.017 21.0724 19.7241 20.7795L16.1049 17.1603ZM15.5962 15.5962C13.0578 18.1346 8.94221 18.1346 6.40381 15.5962C3.8654 13.0578 3.8654 8.94221 6.40381 6.40381C8.94221 3.8654 13.0578 3.8654 15.5962 6.40381C18.1346 8.94221 18.1346 13.0578 15.5962 15.5962Z" :fill="color"/>
      <path d="M14.5 11.2163L7.5 11.2163" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M11 7.71631L11 14.7163" :stroke="color" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </span>
</template>

<script>
export default {
  props: {
    width: { type: Number, default: 24 },
    color: { type: String, default () { return this && this.$store.state.color['coolGrey-500'] } },
    color2: { type: String, default () { return this && this.$store.state.color['coolGrey-50'] } },
    isFixedColor: { type: Boolean },
    isTwoTone: { type: Boolean },
    isSolid: { type: Boolean }
  }
}
</script>
